/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-03-13 13:45:19
 * @LastEditors: yang.chen yang.chen
 * @LastEditTime: 2024-10-17 11:05:51
 * @FilePath: /jsweb/src/router/index.js
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path:'/',
        redirect:'/index'
    },
    {
        path:'*',
        redirect:'/index'
    },
    {
        path: '/',
        component: () => import('../views/IndexView.vue'),
        children: [{
            path: '/index',
            name: 'index',
        }, {
            path: 'partner',
            name: 'applyFor',
            component: () => import('../views/applyFor.vue')
        }, {
            path: 'about',
            name: 'cooperation',
            component: () => import('../views/cooperation.vue')
        }, {
            path: 'careers',
            name: 'aboutUs',
            component: () => import('../views/aboutUs.vue')
        }, {
            path: 'trial',
            name: 'trial',
            component: () => import('../views/trial.vue')
        }, {
            path: 'experience',
            name: 'experience',
            component: () => import('../views/trial.vue')
        }]
    },

]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
